/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { BorderBottomRadius, BorderRadius, BorderTopRadius, BorderRightRadius, BorderLeftRadius } from './bootstrap/scss/mixins/_border-radius.mixin';
import { darken, lighten } from 'polished';

export default $ => css`
  .object-schema-editor-relation-row {
    justify-content: center;
    align-items: center;

    span {
      max-width: 100%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }

    &:nth-of-type(even) {
      background-color: ${$.gray200};
    }
  }

  .preview-container {
    max-height: 350px;
    overflow-y: auto;
    background-color: #f8f9fa;
    border-radius: 5px;
  }

  .preview-content {
    background-color: #fff;
    border: 1px solid #ddd;
    border-radius: 5px;
  }

  .export-uwe-objects{
    .card-header{
        color: ${$.primaryMain} !important;
      }
  }

  form.rjsf {
    margin-top: 0px !important;
  }

  div.collapsable-tree-select {
      appearance: none !important;
      background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='${encodeURIComponent(
        $.primaryMain
      )}' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
      background-repeat: no-repeat;
      background-position: right 12px center;
  }

  .form-tabs{
    margin-top: 0px !important;
  }

  .btn {
    transition: background-color 0.3s ease, transform 0.2s ease !important;
    will-change: transform !important;
    font-family: ${$.fontFamily};
  }

  .btn:not('.dropdown-item .btn'):hover {
    background: ${$.primaryMain} !important;
    transform: scale(1.03) !important;
    border-color: ${$.secondaryMain} !important;
  }

  @keyframes fadeSlideIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }

    .animated-show {
      animation: fadeSlideIn 0.3s ease-out;
    }

    @keyframes slideDown {
    0% {
      max-height: 0;
    }
    100% {
      max-height: 500px;
    }
  }

  .vertical-animated-show {
    animation: slideDown 0.3s ease-out;
    overflow: visible;
  }

  .vertical-animated-slow-show {
    animation: slideDown 0.6s ease-out;
    overflow: hidden;
  }

  .modern-loader {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    animation: fadeIn 0.3s ease;
  }

  .modern-loader.sm .spinner {
    width: 24px;
    height: 24px;
  }

  .spinner {
    animation: rotate 1s linear infinite;
    width: 48px;
    height: 48px;
  }

  .spinner .path {
    stroke: ${$.primaryMain};
    stroke-linecap: round;
    animation: dash 1.5s ease-in-out infinite;
  }

  .loader-text {
    font-size: 14px;
    color: #64748b;
    margin-top: 4px;
  }

  .loader-backdrop {
    position: fixed;
    inset: 0;
    background-color: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(4px);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .loader-center {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  @keyframes rotate {
    100% {
      transform: rotate(360deg);
    }
  }

  @keyframes dash {
    0% {
      stroke-dasharray: 1, 150;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -35;
    }
    100% {
      stroke-dasharray: 90, 150;
      stroke-dashoffset: -124;
    }
  }

  .table.animated-show, table.animated-show {
    animation: fadeInTable 0.3s ease-out forwards;
  }

  @keyframes fadeInCard {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInTable {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  @keyframes fadeInTableRow {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  nav[aria-label='pagination'] {
    display: flex;
    justify-content: flex-end; /* Alinea el contenido del nav a la derecha */
    align-items: center;
    padding: 16px;
    width: 100%;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  nav[aria-label='pagination'] {
    padding: 16px;
    background-color: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }

  .pagination {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    list-style: none;
    margin: 0;
    padding: 0;
    gap: 4px;
    width: 100%;
  }

  .page-item {
    display: inline-flex;
    align-items: center;
  }

  .page-link {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 40px;
    height: 40px;
    padding: 0 12px;
    font-family: ${$.fontFamily}, 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #212121;
    background-color: #ffffff;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
    text-decoration: none;
    transition: all 0.3s ease;
    outline: none;
    cursor: pointer;
  }

  .page-link:focus {
    // box-shadow: 0 0 0 0.2rem rgba(0, 48, 135, 0.25);
  }

  .page-item.disabled .page-link {
    color: #9e9e9e;
    background-color: #f5f5f5;
    border-color: #e0e0e0;
    cursor: not-allowed;
    pointer-events: none;
  }

  .page-item.disabled .page-link:hover {
    background-color: #f5f5f5;
    border-color: #e0e0e0;
  }

  select.form-control {
    border-radius: 4px;
    border: 1px solid hsl(0, 0%, 80%);
    padding: 8px 12px;
    font-family: ${$.fontFamily}, 'Roboto', sans-serif;
    font-size: 14px;
    // font-weight: 500;
    color: #212121;
    width:100%;
    background-color: #ffffff;
    box-shadow: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    height: 40px;
    appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' fill='${encodeURIComponent(
      $.primaryMain
    )}' viewBox='0 0 16 16'%3E%3Cpath d='M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    cursor: pointer;
  }

  select.form-control:focus {
    border-color: ${$.primaryMain}; /* Color de foco */
    // box-shadow: 0 0 0 0.2rem rgba(0, 48, 135, 0.25); /* Anillo de foco */
    outline: none;
  }

  select.form-control:hover {
    border-color: #bdbdbd; /* Borde más oscuro al hover */
    background-color: #f5f5f5; /* Fondo claro */
  }

  @media (max-width: 576px) {
    .pagination {
      flex-wrap: wrap;
      gap: 2px;
    }

    .page-link {
      min-width: 32px;
      height: 32px;
      padding: 0 8px;
      font-size: 12px;
    }

    select.form-control {
      width: 4em;
      height: 32px;
      padding: 6px 10px;
    }
  }

  .card {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
    transition: box-shadow 0.3s ease !important;

    &.square {
      border-radius: 0;
    }

    &.square-top {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    &.square-bottom {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    > .card-header {
      .title {
        font-size: 18px;
        font-weight: 500;
        padding: 5px;
        padding-left: 0px !important;

        &.has-buttons {
          display: inline-block;
          vertical-align: bottom;
        }
      }

      .pagination {
        margin-bottom: 0;
      }
    }

    > .card-footer {
      background-color: #ffffff !important;
      border-top: 1px solid #dee2e6;
      border-radius: 0 0 ${$.borderRadiusLg} ${$.borderRadiusLg};
      .pagination {
        margin-bottom: 0;
        width:100%;
      }
    }

    > table {
      > thead th {
        font-weight: normal;
      }
    }

    &.primary {
      background-color: ${$.gray100};
      color: ${$.black};
      > table {
        background-color: ${$.white};
        > thead * {
          color: ${$.primaryMain};
        }
        > tbody {
          > tr {
            margin-top: 5px;
            background-color: ${$.white};
          }
        }
      }
      > .card-header {
        color: ${$.white};
        background-color: ${$.primaryMain};
      }
    }
  }

  .card.inbox-card {
    margin-bottom: ${$.mainContainerGap};
  }

  .no-bottom-gap {
    margin-bottom: 0 !important;
  }

  input.form-control,
  textarea.form-control,
  button.dropdown-toggle {
    border: 1px solid ${$.inputBorderColor};
    padding: 8px 12px;
    font-size: 14px;
    font-family: ${$.fontFamily}, 'Roboto', sans-serif;
    box-shadow: none;
    transition: border-color 0.3s ease, box-shadow 0.3s ease;
    outline: none;
    width: 100%;
    height: auto;
    line-height: 1.5;
    box-sizing: border-box;
    margin: 0;
    position: relative;
  }


  input.form-control,
  textarea.form-control {
    background-color: #fff;
  }

  input.form-control[type='date'],
  textarea.form-control,
  button.dropdown-toggle,
  .form-group:has(> input.form-control:only-child),
  .form-group:has(> text-area.form-control:only-child),
  .form-group:has(> .control-label + input.form-control[type='text']),
  .form-group:has(> .control-label + input.form-control[type='email']) {
    position: relative;
    height: fit-content;
  }

  input.form-control[type='date']::after,
  button.dropdown-toggle:not(.simple-dropdown-toggle)::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: ${$.primaryMain};
    transition: width 0.3s ease;
    z-index: 2;
  }

  button.dropdown-toggle:disabled, button.dropdown-toggle.disabled{
    ::after {
      display: none;
    }
  }

  input.form-control[type='date']:hover::after,
  button.dropdown-toggle:not(.simple-dropdown-toggle):hover::after {
    width: 100%;
  }

  .input-wrapper {
    position: relative;
    display: inline-block;
    width: 100%;
  }

  .input-wrapper::after,
  .autocomplete__control::after,
  .form-group:has(> input.form-control:only-child)::after,
  .form-group:has(> textarea.form-control:only-child)::after,
  .form-group:has(> .control-label + input.form-control[type='text'])::after,
  .form-group:has(> .control-label + input.form-control[type='email'])::after {
    content: '';
    position: absolute;
    bottom: 0px;
    left: 0;
    width: 0;
    height: 1px;
    background-color: ${$.primaryMain};
    transition: width 0.3s ease;
    z-index: 2;
    margin-left: 3px;
    margin-right: 3px;
  }

  .form-group:has(> input.form-control:only-child)::after,
  .form-group:has(> textarea.form-control:only-child)::after,
  .form-group:has(> .control-label + input.form-control[type='text'])::after,
  .form-group:has(> .control-label + input.form-control[type='email'])::after {
    bottom: 1px;
  }

  .input-wrapper:has(select)::after {
    bottom: 1px;
  }

  .input-wrapper:hover::after,
  .form-group:has(> input.form-control:only-child):hover::after,
  .form-group:has(> textarea.form-control:only-child):hover::after,
  .form-group:has(> .control-label + input.form-control[type='text']):hover::after,
  .form-group:has(> .control-label + input.form-control[type='email']):hover::after,
  .autocomplete__control:hover::after {
    width: calc(100% - 6px);
  }

  input.form-control:focus,
  textarea.form-control:focus,
  button.dropdown-toggle:focus,
  .input-wrapper:focus-within .form-control {
    border-color: ${$.primaryMain};
    // box-shadow: 0 0 0 0.2rem rgba(0, 48, 135, 0.25);
    outline: none;
  }

  input.form-control:focus::after,
  textarea.form-control:focus::after,
  button.dropdown-toggle:not(.simple-dropdown-toggle):focus::after,
  .input-wrapper:focus-within::after,
  .autocomplete__control:focus::after {
    width: 0;
  }

  input.form-control[readonly],
  textarea.form-control[readonly] {
    background-color: #f9f9f9;
    opacity: 0.7;
    color: #333333;
    border-color: ${$.inputBorderColor};
    cursor: not-allowed;
  }

  input.form-control[readonly]:hover::after,
  textarea.form-control[readonly]:hover::after,
  .input-wrapper:hover::after[readonly] {
    width: 0;
  }

  .control-label {
    font-family: ${$.fontFamily}, 'Roboto', sans-serif;
    font-weight: 600;
    margin-bottom: 4px;
    color: #212121;
    font-size: 13px;
  }

  .form-group,
  .input-group {
    margin-bottom: 16px;
    position: relative;
    overflow: visible;
    padding: 0;
  }

  .table {
    font-size: 14px;
    border-collapse: separate;
    border-spacing: 0;
    border-radius: 8px;
  }

  .table thead th {
    border-bottom: 0px !important;
    font-weight: 600;
    padding: 12px 16px;
    border-top: 0 !important;
  }

  .table td {
    // border-bottom: 0px !important;
    padding: 12px 16px;
    vertical-align: middle;
  }

  .workTrayIcon {
    padding-bottom: 20px;
    text-align: center;

    img {
      cursor: pointer;
      max-width: 143px;
      transition: transform 0.3s ease;
    }

    img:hover {
      transform: scale(1.05);
    }

    .label {
      p {
        font-size: 19px !important;
        margin: 0px;
        font-weight: 500;
        font-family: ${$.fontFamily}, 'Roboto', sans-serif;
      }
    }
  }

  .td-actionButtons {
    display: flex;
    justify-content: space-between;
    gap: 8px;
    padding: 4px 0;
  }

  .worktray {
    min-height: 500px;
    > .card:not(.form-errors) {
      box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
      background-color: #ffffff;
      border-radius: 0px !important;

      .card-header {
        border-radius: 10px 10px 0px 0px;
        padding: 10px 15px;
      }

      .btn:not(.dropdown-toggle):not(.filter-button):not(.btn-clear) {
        margin: 5px !important;
        padding: 4px 8px !important; 
        border-radius: 4px;
        text-transform: uppercase;
        font-weight: 500;
        font-size: 12px;
        color: #ffffff;
        transition: background-color 0.3s ease;
      }

      .btn.filter-button{
        color: white !important;
        background: transparent !important;
        border: none;
        transition: transform 150ms ease-in-out;
      }
      .btn.filter-button:hover, .btn.filter-button.active{
        transform: scale(1.2);
      }

      .worktray-table-container > .table,
      > table {
        margin-bottom: 0;

        > * > tr {
          > th {
            height: 38px;
            padding: 8px 11px;
            font-weight: 500;
            border-bottom: 1px solid #e0e0e0; /* Subtle border */
          }

          > td {
            padding: 6px 11px;
            border-bottom: 1px solid #e0e0e0;

            div.alert {
            margin-bottom: 0px !important;
            }
          }

          > th > .btn,
          > td > .btn {
            white-space: nowrap;
            text-overflow: clip;
            padding: 3px 6px !important;
          }
        }
      }
    }
  }

  .icon-button {
    box-shadow: none !important;

    [class$="-icon"] {
      rect {
        stroke: ${$.primaryMain} !important;
        fill: ${$.primaryMain} !important;
      }
    }

    &:not(.active):hover {
      background-color: ${darken(0.1, $.white)};
      [class$="-icon"] {
        rect {
          stroke: ${$.primaryMain} !important;
          fill: ${$.primaryMain} !important;
        }
      }
    }

    &.active {
      [class$="-icon"] {
        rect {
          stroke: ${$.white} !important;
          fill: ${$.white} !important;
        }
      }

      &:hover {
        background-color: ${darken(0.1, $.primaryMain)} !important;
      }
    }
  }
  
  .mui-sidebar {
    position: relative;
    width: 280px;
    display: flex;
    flex-direction: column;
    transition: width 0.3s ease;
    overflow: hidden;
    flex-shrink: 0;
    border-right: 1px solid rgba(255, 255, 255, 0.5);
    box-shadow: 2px 0 28px rgba(0, 0, 0, 0.07);
  }

  .mui-sidebar::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(180deg, rgba(255, 255, 255, 0.72) 0%, rgba(248, 250, 255, 0.65) 100%);
    backdrop-filter: blur(14px);
    -webkit-backdrop-filter: blur(14px);
    pointer-events: none;
    z-index: -1;
  }

  .mui-sidebar.mui-collapsed {
    width: 60px;
  }

  @media only screen and (max-width: 850px) {
    *, html body {
        font-size: 13px !important;
    }
  
    .mobile-table{
      background: #ffffff;
      height: 100%;
      overflow: auto;

      > .card {
        border-radius: 0 !important;
      }

      .loader-container {
        height: 100%;
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
    
    .worktray-filters-collapse {
      position: absolute;
      z-index: 1;
      width: 100%;
      top: 51px;
    }


    .show-when-mobile {
      display: block !important;
    }

    .mui-sidebar.mui-collapsed {
      width: 0px;
    }
  }

  .card:not(.form-errors) {
      display: flex;
      flex-direction: column;
      min-width: 0;
      height: ${$.cardHeight};
      word-wrap: break-word;
      background-color: ${$.cardBg};
      background-clip: border-box;
      // border: ${$.cardBorderWidth} solid ${$.cardBorderColor};
  
      > hr {
        margin-right: 0;
        margin-left: 0;
      }
  
      > .list-group {
        border-top: inherit;
        border-bottom: inherit;
  
        &:first-of-type {
          border-top-width: 0;
          ${new BorderTopRadius($.cardInnerBorderRadius).include($)};
        }
  
        &:last-child {
          border-bottom-width: 0;
          ${new BorderBottomRadius($.cardInnerBorderRadius).include($)};
        }
      }
  
      > .card-header + .list-group,
      > .list-group + .card-footer {
        border-top: 0;
      }
    }

    .worktray >.card{
        border-radius: 0px !important;
        background: transparent !important;
        border: 0 !important;
    }

    table{
    background:#ffffff;
    }

  .form-control:disabled, .form-control[readonly] {
      background-color: #f9f9f9;
      opacity: 0.7;
      color: #333333;
      border-color: #ced4da;
      cursor: not-allowed;
  }

  select.form-control:disabled,
  select.form-control[readonly] {
    background-image: none;
  }

  .mui-sidebar.mui-collapsed > .mui-sidebar-menu > .pc-item.pc-caption {
    padding: 0 !important;
    margin: 4px 16px;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    overflow: hidden;
    height: 0;
  }

  .mui-sidebar.mui-collapsed > .mui-sidebar-menu > .pc-item.pc-caption label {
    display: none;
  }
  
  .mui-sidebar.mui-collapsed .mui-sidebar-text {
    max-width: 0;
    opacity: 0;
    transition: max-width 0.2s ease, opacity 0.1s ease;
  }
  
  .mui-sidebar.mui-collapsed .nav-clock {
    display: none;
  }

  .mui-sidebar-header {
    padding: 16px;
    padding-bottom: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 0px;
  }

  .mui-sidebar-text {
    white-space: nowrap;
    overflow: hidden;
    max-width: 250px;
    opacity: 1;
    transition: max-width 0.25s ease 0.05s, opacity 0.2s ease 0.12s;
  }

  .mui-sidebar.mui-expanded .mui-sidebar-text {
    white-space: normal;
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-header {
    padding-right: 0px;
  }
  
  .mui-sidebar-header h2 {
    font-size: 20px;
    font-weight: 500;
    color: #1976d2;
    margin: 0;
    display: flex;
    align-items: center;
  }

  .mui-sidebar-header .navbar-brand.nav-logo-icon {
  display: flex !important;
  justify-content: flex-start !important;
  align-items: center !important;
  flex: 1 !important;
  min-width: 0 !important;
  gap: 8px !important;
  padding: 0 !important;
  margin: 0 !important;
  text-decoration: none !important;
  outline: none !important;
}

.mui-sidebar-header .navbar-brand.nav-logo-icon > * {
  flex-shrink: 0 !important;
}

.sidebar-logo-wrapper {
  position: relative;
  display: inline-flex;
  flex-shrink: 0;
}

.sidebar-logo-wrapper svg,
.sidebar-logo-wrapper img {
  transition: transform 0.18s ease, filter 0.18s ease, height 0.3s ease, width 0.3s ease;
}

.sidebar-logo-wrapper:hover svg,
.sidebar-logo-wrapper:hover img {
  transform: scale(1.07);
  filter: brightness(1.1);
}

.sidebar-logo-badge {
  position: absolute;
  bottom: -4px;
  right: -6px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${lighten(0.2, $.primaryMain)};
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.35);
  pointer-events: none;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.sidebar-logo-wrapper:hover .sidebar-logo-badge {
  opacity: 0;
  transform: scale(0.5);
}

body.dark-mode .sidebar-logo-badge {
  box-shadow: 0 1px 5px rgba(0,0,0,0.6);
}

body.dark-mode .sidebar-logo-wrapper:hover svg,
body.dark-mode .sidebar-logo-wrapper:hover img {
  filter: brightness(1.1);
}

  .mui-sidebar.mui-collapsed .mui-sidebar-header h2 span {
    display: none;
  }

  .mui-toggle-btn {
    background: none;
    border: none;
    cursor: pointer;
    color: #757575;
    padding: 8px;
    border-radius: 6px;
    transition: background-color 0.2s;

    .fa {
      font-size: 18px !important;
    }
  }

  .mui-toggle-btn:hover {
    background-color: #e0e0e0;
  }

  .mui-sidebar-menu {
    flex-grow: 1;
    list-style: none;
    padding: 8px 0;
    overflow-y: auto;
    overflow-x: hidden;
    scroll-behavior: smooth;
  }

  .mui-sidebar-menu {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.1) transparent;
  }
  .mui-sidebar-menu::-webkit-scrollbar {
    -webkit-appearance: none;
    width: 2px;
  }
  .mui-sidebar-menu::-webkit-scrollbar-track {
    background: transparent;
  }
  .mui-sidebar-menu::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.18);
    border-radius: 2px;
  }
  .mui-sidebar-menu::-webkit-scrollbar-thumb:hover {
    background: rgba(0, 0, 0, 0.32);
  }

  .mui-menu-item {
    position: relative;
    display: flex;
    align-items: center;
    margin: 1px 0;
    padding: 8px 12px;
    color: ${$.gray600};
    text-decoration: none !important;
    border-radius: 0;
    overflow: hidden;
    z-index: 1;

    &:active,
    &:focus {
      text-decoration: none !important;
    }
  }

  a:hover.mui-menu-item {
    text-decoration: none !important;
  }

  .mui-text{
    font-size: 12px;
    font-weight: 400;
    color: ${$.gray600};
  }

  .mui-menu-item::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: ${$.primaryMain};
    opacity: 0.1;
    transform: scaleX(0);
    transform-origin: center;
    transition: transform 0.3s ease;
    z-index: 0;
    border-radius: 0;
  }

  .mui-menu-item:hover::before {
    transform: scaleX(1);
  }

  .mui-menu-item > * {
    position: relative;
    z-index: 1;
  }

  .mui-menu-item.active {
    color: ${$.primaryMain};

    .mui-text {
      color: ${$.primaryMain};
      font-weight: 500;
    }
  }

  .mui-menu-item.active::before {
    content: '';
    position: absolute;
    inset: 0;
    background-color: ${$.primaryMain}1A;
    opacity: 0.92;
    border-radius: 0;
    z-index: 0;
    transform: scaleX(1);
    transform-origin: center;
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.22);
    backdrop-filter: blur(4px);
  }

  @keyframes sidebar-accent-glow {
    0%, 100% { box-shadow: 0 0 4px 1px ${$.primaryMain}40; }
    50%       { box-shadow: 0 0 9px 3px ${$.primaryMain}55; }
  }

  .mui-menu-item.active::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 55%;
    background-color: ${$.primaryMain};
    // background: rgba(255, 255, 255, 0.7);
    border-radius: 0 3px 3px 0;
    z-index: 2;
    animation: sidebar-accent-glow 2.8s ease-in-out infinite;
  }

  @keyframes sidebar-item-enter {
    from { opacity: 0; transform: translateY(7px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .animate-items .mui-menu-li {
    animation: sidebar-item-enter 0.28s ease-out both;
  }

  /* ── Generic staggered reveal — same feel as the sidebar's tab entrance,
     reused wherever a loading spinner is replaced by real rows/cards/tiles
     (WorkTray, CardTray, the settings switchboard). Pair with an inline
     animationDelay per item (see util/staggerDelay). ── */
  .stagger-item {
    animation: sidebar-item-enter 0.25s ease-out both;
  }

  .mui-menu-item span.mui-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 12px;
    text-align: center;
    flex-shrink: 0;
    transition: margin 0.3s ease, transform 0.18s ease;
  }

  .mui-sidebar:not(.mui-collapsed) .mui-menu-item:hover span.mui-icon {
    transform: translateX(2px);
  }

  .mui-sidebar:not(.mui-collapsed) .mui-menu-item.active span.mui-icon {
    transform: translateX(2px) scale(1.1);
  }

  .mui-sidebar.mui-collapsed .mui-menu-item.active span.mui-icon {
    transform: scale(1.15);
  }

  .mui-sidebar.mui-collapsed .mui-menu-item {
    justify-content: center;
    padding: 10px;
  }

  .mui-sidebar.mui-collapsed .mui-menu-item .mui-icon {
    margin: 0;
  }

  .mui-sidebar.mui-collapsed .mui-menu-item span.mui-text {
    /* visibility handled by .mui-sidebar-text max-width + opacity transition */
  }

  .mui-sidebar-footer {
    border-top: 1px solid rgba(0, 0, 0, 0.07);
    flex-shrink: 0;
  }

  .mui-sidebar-footer .mui-menu-item {
    padding: 7px 16px;
    font-size: 13px;
    margin: 2px 0;


    .mui-text {
      white-space: nowrap !important;
    }
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-footer .mui-menu-item {
    padding: 7px;
  }

  .mui-sidebar-footer .mui-menu-item span.mui-icon {
    transition: margin 0.3s ease, transform 0.18s ease;
  }

  .mui-sidebar:not(.mui-collapsed) .mui-sidebar-footer .mui-menu-item:hover span.mui-icon {
    transform: translateX(2px);
  }

  .mui-sidebar:not(.mui-collapsed) .mui-sidebar-footer .mui-menu-item.active span.mui-icon {
    transform: translateX(2px) scale(1.1);
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-footer .mui-menu-item.active span.mui-icon {
    transform: scale(1.15);
  }

  .mui-sidebar-footer-top {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 10px 12px 6px;
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-footer-top {
    flex-direction: column;
    padding: 10px 0 8px;
    align-items: center;
    gap: 6px;
  }

  .mui-sidebar-footer-actions {
    display: flex;
    flex-direction: column;
    padding: 0 8px 8px;
    gap: 2px;
    overflow: hidden;
    max-height: 200px;
    opacity: 1;
    transition: max-height 0.25s ease, opacity 0.2s ease 0.08s, padding 0.25s ease;
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-footer-actions {
    max-height: 0;
    opacity: 0;
    padding: 0;
    pointer-events: none;
  }

  .mui-sidebar-footer-action-btn {
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;
    background: none;
    border: none;
    cursor: pointer;
    padding: 6px 8px;
    border-radius: 6px;
    font-size: 13px;
    color: #5b6b79;
    text-align: left;
    transition: background 0.2s;

    .fa, .fas {
      width: 16px;
      text-align: center;
      font-size: 14px;
    }
  }

  .mui-sidebar-footer-action-btn:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .mui-sidebar-footer-action-btn.text-danger {
    color: #dc3545;
  }

  .mui-sidebar-user-widget {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 4px 8px;
    border-radius: 8px;
    cursor: pointer;
    transition: background 0.2s;
    flex: 1;
    min-width: 0;
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-user-widget {
    flex: 0 0 auto;
    padding: 4px;
  }

  .mui-sidebar-user-widget:hover {
    background: rgba(0, 0, 0, 0.06);
  }

  .mui-sidebar-user-details {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-user-details {
    display: none;
  }

  .mui-sidebar-user-name {
    display: block;
    font-size: 12px;
    font-weight: 600;
    color: #424242;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .mui-sidebar-user-role {
    display: block;
    font-size: 11px;
    color: #757575;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* ── Sidebar skeleton loader ───────────────────────────────── */
  @keyframes sidebar-skeleton-pulse {
    0%, 100% { opacity: 0.35; }
    50% { opacity: 0.72; }
  }

  .mui-menu-item-skeleton {
    display: flex;
    align-items: center;
    margin: 4px 0;
    padding: 10px 9px;
    gap: 12px;
    border-radius: 0;
  }

  .skeleton-circle {
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: rgba(0, 0, 0, 0.1);
    flex-shrink: 0;
    animation: sidebar-skeleton-pulse 1.6s ease-in-out infinite;
  }

  .skeleton-line {
    height: 12px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.08);
    animation: sidebar-skeleton-pulse 1.6s ease-in-out infinite;
  }

  /* ── Sidebar footer user row (desktop) ────────────────────── */
  .mui-sidebar-footer-user-row {
    display: flex;
    align-items: center;
    gap: 4px;
    padding: 2px 8px 6px;
  }

  .mui-sidebar.mui-collapsed .mui-sidebar-footer-user-row {
    justify-content: center;
    padding: 2px 0 6px;
  }

  /* ── Mobile footer ──────────────────────────────────────────── */
  .mui-sidebar-footer-mobile {
    border-top: none;
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }

  .mui-sidebar-footer-mobile .mui-sidebar-footer-top {
    cursor: pointer;
  }

  .mui-sidebar-footer-toggles {
    padding: 6px 8px;
    border-radius: 6px;
    background: rgba(0, 0, 0, 0.03);
  }

  .mui-sidebar-mobile-links {
    display: flex;
    border-top: 1px solid rgba(0, 0, 0, 0.06);

    .mui-menu-item {
      flex: 1;
      justify-content: center;
      padding: 8px 4px;
      font-size: 12px;

      .mui-icon {
        font-size: 16px;
        margin-right: 4px;
        width: auto;
      }
    }
  }

  .mui-sidebar-chevron {
    font-size: 14px;
    color: #9e9e9e;
    transition: transform 250ms ease-in-out;
    flex-shrink: 0;
  }

  .mui-sidebar-chevron.flipped {
    transform: rotate(180deg);
  }

  .sidebar-tooltip-inner {
    background: rgba(30, 34, 46, 0.92);
    backdrop-filter: blur(8px);
    -webkit-backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 6px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.22);
    font-size: 12px;
    font-weight: 500;
    padding: 5px 10px;
    color: #f0f2f8;
    white-space: nowrap;
  }

  .mui-main-content {
    flex-grow: 1;
    flex-shrink: 1;
    overflow: auto;
    background: white;
    .navbar {
      background: white;
    }
  }

  @media (max-width: 768px) {
    .mui-sidebar-header h2 span {
      display: none;
    }

    .mui-sidebar div.user-name {
      font-size: 10px !important;
    }

    .mui-sidebar-menu {
      .nav-item{
        width: 100% !important;
      }
    }

    .pc-user-card {
      small {
        font-size: 13px !important;
      }
    }
    
    .mui-menu-item span.mui-text {
       font-size: 13px !important;
    }

    }

    body {
      display: flex !important;
      min-height: 100vh !important;
    }

    .app-layout {
      display: flex !important;
    }

    nav.navbar {
      color: ${$.primaryMain};
      height: ${$.navbarHeight};
      border-bottom: 1px solid rgba(255, 255, 255, 0.55);
      box-shadow: 0 1px 20px rgba(0, 0, 0, 0.06);
      padding: 0 8px;
      top: 0;
      right: 0;
      position: fixed;
      background: rgba(255, 255, 255, 0.78);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      z-index: 1000;
  }

  .nav-logo-icon {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .pc-item {
      margin: 0 10px;
      label {
      display: inline-block;
      margin-bottom: 0rem;
  }

}

  .pc-caption:first-of-type {
      padding-top: 10px !important;
  }

  .pc-caption {
      display: block;
      padding: 24px 23px 8px !important;
      padding-bottom: 0 !important;
      color: #3e4853;
      text-transform: uppercase;
      position: relative;
      line-height: 1.66;
      font-size: 11px;
      font-weight: 600;
  }

  .mui-sidebar .card {
    margin: 15px;
    border-radius: 5px 5px 5px 5px !important;
  }


  // .table{
  //   border-radius: 0px !important;
  // }

  .user-nav-dropdown .dropdown-menu {
    top: 100% !important;
    left: auto !important;
    right: 0 !important;
    transform: none !important;
  }

  .card.pc-user-card .pc-user-links button {
    display: flex;
    align-items: center;
    color: #5b6b79;
    padding: 8px 0px;
    all: unset;
    margin: 5px;
    font-size:13px;
    cursor:pointer;
  }

  .card.pc-user-card .pc-user-links button:hover {
    color: ${$.primaryMain};
  }

  .card.pc-user-card .pc-user-links button i {
    font-size: 18px;
    margin-right: 10px;
  }
  .card.pc-user-card .pc-user-links a:focus, .card.pc-user-card .pc-user-links a:hover {
    color: #5b6b79;
  }

  .pc-user-item{
    padding: 10px;
    padding-top: 0px;
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 400;
    color: #5b6b79;
  }

  .pc-user-item-suboption {
    width: 100% !important;
    display: block !important;
    padding-left: 18% !important;
  }

  .pc-user-item-suboption:disabled,
  .pc-user-item-suboption[disabled] {
    width: 100% !important;
    display: block !important;
    padding-left: 18% !important;
    color: #000000 !important;
    cursor: default !important;
  }
    
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: #888;
    border-radius: 10px;
    border: 2px solid transparent;
    background-clip: content-box;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555;
  }

  * {
    scrollbar-width: thin;          /* thin | auto | none */
    scrollbar-color: #888 transparent;
  }

  .collapsable-tree-select button:not(.dropdown-item button){
    margin: 0px !important;
    min-height: 39px;
    background: transparent !important;
    color: #000000 !important;

    &:disabled, .disabled {
      background-color: #f9f9f9 !important;
      opacity: 0.7;
      color: #333333 !important;
      border-color: #ced4da !important;
      cursor: not-allowed;
    }

    white-space: nowrap;
  }

  .form-settings{
    .collapsable-tree-select button:not(.dropdown-item button){
      white-space: break-spaces;
    }
  }

  .collapsable-tree-select .btn{
      margin: 0px !important;
  }

  .collapsable-tree-select button:not('.dropdown-item .btn'):hover{
      margin: 0px !important;
      background: transparent !important;
      min-height: 39px;
      color: #000000 !important;
      white-space: nowrap;
      border: 1px solid #ced4da;
  }

  .collapsable-tree-select button::after{
    all:unset;
  }

  .medium-panel {
    width: 450px;
    max-height: 550px;
    overflow-y: auto;
    box-shadow: 0 4px 24px 0 rgba(62, 57, 107, 0.18);
    border: none;
    padding: 8px;
      position: absolute;
    inset: 0px 0px auto auto;
    margin: 0px;
    border-radius: 4px;
    padding: 26px;

  .dropdown-item {
      margin-left: 0px;
      margin-right: 0px;
      border-radius: 4px;
      padding: 16px;
      font-size: 14px;
      cursor: pointer;
  }

  .dropdown-item:not(:first-of-type) {
    margin-top: 10px;
  }

  .badged-icon {
    position: relative;
    padding-top: 20px;
  }

  .badged-icon .notification-date {
      position: absolute;
      top: 13px;
      right: 10px;
      font-size: 12px;
      color: #666;
  }

  p {    
    margin-top: 20px;
  }

  div.title {
    font-weight: 600;
    padding-left: 5px;
    margin-top: 5px !important;
    }

  }

  button.dropdown-toggle{
    margin: 0px !important;
    white-space: nowrap;
  }

  button.dropdown-toggle .btn{
      margin: 0px !important;
  }

  button.dropdown-toggle:hover{
    margin: 0px !important;
    white-space: nowrap;
    transform: none !important;
    border-width: 1px;
    border-style: solid;
  }

  // button.dropdown-toggle::after{
  //   all:unset;
  // }

  // .dropdown-item .btn{
  //   all:unset;
  // }

  .rjsf-field-array-of-object,
  .field-array-of-object{
    table{
      overflow: visible;
    }
  }

  .full-width {
    grid-column: 1 / -1; /* ocupa desde la primera hasta la última columna */
  }

  .tab-content{
    height: 100%;

    > .tab-pane.active {
      height: 100%;
    }

    .card-body{
      background: #FFFFFF !important;
    }
  }

  .search-bar{
    border: none !important;

    .rjsf-field-boolean > div.checkbox {
      label { cursor: pointer; }
      height: 100%;
      display: flex;
      align-items: center;
    }
  }
  
  .search-bar.card {
    border-radius: 0 !important;

    > .card-body {
      border-radius: 0 !important;
      padding-bottom: 0;
      padding-top: 0;

      > .rjsf {
        margin: 0;

        > .rjsf-field-object {
          margin: 0;

          > .rjsf-form-group {
            margin-bottom: 0 !important;

            .mb-3 {
              margin-bottom: 8px;
            }
          }
        }
      }
    }

    > .card-footer {
      border-top: none !important;
      padding-top: 0;
    }
  }

  .collapsable-tree-select >.dropdown-toggle >span {
    overflow: visible;
  }

  .modern-hover-icon {
    font-size: 2rem;
    transition: all 0.1s ease;
  }

  .modern-hover-icon:hover {
    color: ${$.secondaryMain};
    transform: scale(1.2) rotate(2deg);
  }


  .mui-main-content{
    .navbar-nav .nav-link:not(.dropdownOrganizationSelected){
      padding-right: 0px !important;
      padding-left: 0px !important;
    }
  }

  .mui-user-dropdown .card {
    margin: 15px;
    border-radius: 5px 5px 5px 5px !important;
  }

  .mui-user-dropdown .card.pc-user-card {
    margin: 10px;
    box-shadow: none;
    background: #e7e7e7cc;
  }

  .mui-user-dropdown .card.pc-user-card .card-body {
    padding: 15px;
  }

  .mui-user-dropdown .card.pc-user-card .pc-user-links a {
    display: flex;
    align-items: center;
    padding: 8px 0px;
  }

  .mui-user-dropdown .card.pc-user-card .pc-user-links a i {
    font-size: 18px;
    margin-right: 10px;
  }

  .pc-user-item{
    padding: 10px;
  }
  
  .medium-panel-user {
    width: 300px;
    max-height: 550px;
    overflow-y: auto;
    box-shadow: 0 4px 24px 0 rgba(62, 57, 107, 0.18);
    border: none;
    position: absolute;
    inset: 0px 0px auto auto;
    margin: 0px;
    border-radius: 4px;
    padding: 0px;
  }

  .dropdown-item {
      margin-left: 0px;
      margin-right: 0px;
      border-radius: 4px;
      padding: 0.2rem 0 0.2rem 0.5rem;
      font-size: 14px;
      cursor: pointer;

      .collapse {
        transition-duration: 150ms;
      }
      
      > button {
        height: 20px;
        width: 15px;
        padding: 0;
        display: inline-flex;
        align-items: center;
        justify-content: center;

        .fa-caret-down {
          font-size: 15px;
          transition: transform 150ms ease-in-out, font-size 150ms ease-in-out;
          
          &:hover {
            font-size: 20px;
            color: ${$.primaryMain};
          }
        }

        .fa-caret-down.rotate-90-ctclockwise {
          transform: rotate(-90deg);
        }
      }
  }

  .dropdown-organization-selected {
    .dropdown-item {
      border: none !important;
    }
      .dropdown-divider {
        border-top: 1px solid #eeeeee;
        margin: 0px;
    }
  }

  @media (max-width: 576px) {
      select.form-control {
          width: 100%;
          height: 39px;
          padding: 6px 10px;
      }
  }

  @media (max-width: 768px) {
    .mui-sidebar.mui-collapsed {
      width: 0px;
    }

    .mui-sidebar {
      width: 280px;
      position: fixed;
      background: #f5f5f5;
      top: 0;
      left: 0;
      height: 100vh;
      z-index: 1050;
      box-shadow: 2px 0 5px rgba(0, 0, 0, 0.3); /* Para dar efecto de capa encima */
    }
  }

  .uweentity-form form.rjsf legend[id^='root_'][id$='__title'], .form-component legend,
  .form-subtitle  {
      position: relative;
      cursor: default;
      background-color: transparent;
      font-size: 14px !important;
      border-radius: 0.125rem 0.125rem 0 0;
      margin-bottom: 8px;
      font-weight: 500 !important;
      text-transform: uppercase !important;
      color: ${$.gray500} !important;
  }


  form.rjsf legend[id^='root_'][id$='__title'] >.expandable {
      color: ${$.primaryMain};
  }

  .uweentity-form{
    .card:not(.card-shadow) {
      box-shadow: none !important;
    }

    .card-footer-container {
      background-color: white !important;
      height: auto;
      padding-bottom: 8px;

      .card-footer {
        padding: 0;
        padding-top: 8px;
        padding-right: 8px;
      }
    }
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-tab {
      text-transform: uppercase;
      letter-spacing: 1.25px;
      border-width: 0;
      border: 1px solid ${$.primaryMain};
      border-bottom: 0px;
      border-top-right-radius: 10px;
      border-top-left-radius: 10px;
  }

  .form-container{
    margin-bottom: 10px !important;
  }

  .form-control.composite-input-field {
      min-height: 40px;
      border: 1px solid ${$.inputBorderColor} !important;
      // max-width: 20rem;
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-panel {
      border-top-right-radius: 10px !important;
      border-top-left-radius: 10px !important;
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-panel >.card-header {
      border-top-right-radius: 8px;
      border-top-left-radius: 8px;
  }

  .form-container >.sidepanel >.expandable-tab-side-panel-panel >.card-header {
    position: relative;
    font-size: 16px;
    font-weight: bold;
    padding: 10px;
  }
  
  .form-container >.sidepanel >.expandable-tab-side-panel-panel >.card-header >.btn-bar {
    position: absolute;
    right: 6px;
    top: 8px;
    padding: 0;
  }

  .uweentity-form-full-expanded-sidepanel .card-header {
      position: relative;
      color: white;
      background-color: ${$.primaryMain};
      font-size: 16px;
      padding: 10px;
      font-weight: bold;
      display: flex;
      justify-content: space-between;
      align-items: center;

      > .btn-bar > .btn {
        background: transparent;
        border: none;
        border-radius: 50%;
        color: white;

        &:hover {
          color: ${$.primaryMain};
          background-color: white;
        }
      }
  }

  form.rjsf .form-group.bordered {
    border: 1px solid #f5f5f5;
    border-radius: 10px;
    padding: 10px;
  }

  .checkbox-toggle-button-field >.checkbox {
    color: #fff;
  }

  div.dropdown{
    .dropdown-menu {
      border: 0px solid rgba(0,0,0,0.15);
    }
  }

  div.form-submit-buttons {
    button {
      text-transform: uppercase;
      border-radius: 4px;
      font-size: 13px;
    }
    button:hover{
      color: #fff;
    }
  }

  .form-submit-buttons>:not(:first-of-type) {
    margin-left: 10px;
  }

  form.rjsf legend[id^='root_'][id$='__title'],
  .object-section-title > .form-group > .control-label {
    position: relative;
    // color: ${$.primaryMain};
    background: transparent;
    font-size: 1.5rem;
    font-weight: bold;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    font-size: 16px;
    font-weight: bold;
    border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding: 10px 0px;
    border-bottom: 0px !important;
  }

  legend[id$="_ns"].type-section {
    position: relative;
    // color: ${$.primaryMain};
    background: transparent;
    // font-size: 1.5rem;
    // font-weight: bold;
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
    // font-size: 16px;
    font-weight: bold;
    // border-bottom: 1px solid rgba(0, 0, 0, 0.125);
    padding: 10px 0;
  }

  [id^="root_array"] {
    legend[id$="_ns"].type-section {
        border-bottom: 0px !important;
    }
  }

  .form-errors .card-header {
    background: ${$.primaryMain} !important;
    border-radius: 10px 10px 0 0;
  }

  .form-errors {
    border: none !important;
    background-color: transparent  !important;

    .form-error-list {
      border-left: 1px solid ${$.primaryMain};
      border-right: 1px solid ${$.primaryMain};
    }
  }

  .settings-landing-page {
    height: auto;
  }

  .animate-transform {
    transition: transform 200ms ease-in-out;
    transform-origin: center;
  }

  .rotate180 {
    transform: rotate(180deg);
  }
}

.array-item-add {
  white-space: nowrap;
  margin-left: 1em;
  margin-top: 16px;
}

.array-item {
  margin-left: 1em;
  padding-bottom: 1em;
}

.mt-0 {
  margin-top: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}
`;
